import { forwardRef } from 'react'
import HeroIcon, { HeroIconProps } from '../HeroIcon'

export default forwardRef<SVGSVGElement, HeroIconProps>((props, ref) => {
  const { type = 'solid', ...rest } = props
  return <HeroIcon ref={ref} Component={Component} {...rest} />
})

const Component = forwardRef<SVGSVGElement, any>((props, ref) => {
  return (
    <svg ref={ref} width="27" height="23" viewBox="0 0 27 23" fill="none" {...props}>
      <path
        d="M2.4888 2.24997L2.48881 10.3965C2.48881 14.8147 6.07053 18.3965 10.4888 18.3965L24.1352 18.3965"
        stroke="url(#paint0_linear_8025_26677)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21.1353 15.75C21.1353 14.926 22.076 14.4556 22.7353 14.95L26.0686 17.45C26.6019 17.85 26.6019 18.65 26.0686 19.05L22.7353 21.55C22.076 22.0444 21.1353 21.574 21.1353 20.75V15.75Z"
        fill="white"
      />
      <line
        x1="8.13525"
        y1="3.75"
        x2="24.1353"
        y2="3.75"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="8.13525"
        y1="9.75"
        x2="18.1353"
        y2="9.75"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8025_26677"
          x1="14.687"
          y1="8.94823"
          x2="3.86379"
          y2="19.7714"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  )
})
